import React from 'react';
import {observer} from 'mobx-react-lite';
import {FormField} from '../../../../components/form-field/form-field';
import CheckboxesTreeDropdown from '../../../../components/inputs/checkboxes-tree-dropdown/checkboxes-tree-dropdown';
import {Button} from '../../../../components/inputs/button/button';
import {BUTTON_VARIANTS} from '../../../../components/inputs/button-variants';
import {IValidationGroup} from '../../../../hooks/validation-group/validation-group-hook';
import SbrMarginsFields from './sbr-margins-fields';
import SbrMarginGroupStore from '../stores/sbr-margin-group-store';
import SbrMarginGroupsEditorStore from '../stores/sbr-margin-groups-editor-store';
import './sbr-margin-group-card.scss';

export interface ISbrMarginGroupCardProps {
    groupStore: SbrMarginGroupStore;
    marginGroupsStore: SbrMarginGroupsEditorStore;
    disabled?: boolean;
    isLoadingOptions?: boolean;
    validationGroup?: IValidationGroup;
}

/** Renders a single SBR margin group with shipping options and margin inputs. */
const SbrMarginGroupCard: React.FC<ISbrMarginGroupCardProps> = observer(({
    groupStore,
    marginGroupsStore,
    disabled = false,
    isLoadingOptions = false,
    validationGroup,
}) => {
    const groupOptions = marginGroupsStore.getShipmentOptions();

    return (
        <div className="sbr-margin-group-card">
            <div className="sbr-margin-group-card__header">
                <Button
                    variant={BUTTON_VARIANTS.Transparent}
                    text="Remove Group"
                    onClick={() => marginGroupsStore.removeGroup(groupStore.clientId)}
                    disabled={disabled}
                />
            </div>

            <div className="sbr-margin-group-card__content">
                <FormField label="Shipping options" required>
                    <CheckboxesTreeDropdown
                        compressed={false}
                        options={groupOptions}
                        value={groupStore.getSelectedSelectionsTreeItems()}
                        onChange={(value) => groupStore.setSelections(value)}
                        checkboxesSelectAllText="Select all"
                        isCheckboxesListDisabled={disabled || isLoadingOptions}
                        searchInputPlaceholder="Select shipping options"
                    />
                </FormField>

                <SbrMarginsFields
                    fixedMargin={groupStore.getFixedMargin()}
                    relativeMargin={groupStore.getRelativeMargin()}
                    onFixedMarginChange={groupStore.setFixedMargin}
                    onRelativeMarginChange={groupStore.setRelativeMargin}
                    fixedMarginLabel="Fixed margin"
                    relativeMarginLabel="Relative margin"
                    required={groupStore.hasIncompleteFields()}
                    disabled={disabled}
                    validationGroup={validationGroup}
                />
            </div>
        </div>
    );
});

export default SbrMarginGroupCard;
